import React, { useEffect } from 'react';
import { usePrivacyPolicy } from './hooks/PrivacyPolicy.hook';
import PrivacyPolicyView from './views/PrivacyPolicyView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const PrivacyPolicyController = () => {
  const { isLoading, spacesData } = usePrivacyPolicy();
  if (isLoading) {
    return <LoadingComponent loading={isLoading} />;
  } else {
    return <PrivacyPolicyView spacesData={spacesData} />;
  }
};

export default PrivacyPolicyController;
